export default __webpack_public_path__ + "static/media/my_portfolio_image_1.9fe98ec2.jpg";